import useEventChatPageElement from '../../../hooks/adminChats/useEventChatPageElement';

const EventChatPage = () => useEventChatPageElement();

export default EventChatPage;
